import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: 'https://sso.tatamotors.com/auth/', // e.g., 'https://your-keycloak-
  realm: 'internal',
  clientId: 'finance-manual-rag-pv-ev',
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
